export default __webpack_public_path__ + "static/new-perspective-page-preview-section-bg-f0db52acfe4e87a73ab419888f112ead.jpg";